import { Provider } from '@angular/core';
import { SolLaborReportsService } from './labor-reports/sol-labor-reports.service';
import { SolCostReportService } from './cost-reports/sol-cost-report.service';
import { SolSubContractorMiscellaneousService } from './subcontractor-miscellaneous-reports/sol-sub-contractor-miscellaneous.service';
import { SolSystemsReportService } from './system-reports/sol-systems-report.service';
import { SolMaterialService } from './material-reports/sol-material.service';
import { SolChecklistBaseService } from './check-list-reports/sol-checklist-base.service';
import { FireEstimatingService } from './fire-estimating/fire-estimating.service';
import { TaskBasedLaborService } from './task-based-labor/task-based-labor.service';
import { ElectricalReportService } from './electrical-service/electrical-report.service';
import { SolMaterialByAreaService } from './material-by-area/sol-material-by-area.service';
import { SolMaterialByCountryService } from './material-by-country/sol-material-by-country.service';
import { SolMaterialRelatedReportsService } from './material-related-reports/sol-material-related-reports.service';
import { WiringTypesService } from './wiring-types/wiring-types.service';
import { SpecialPricingReportService } from './special-pricing-reports/special-pricing-report.service';
import { EstimateOverviewReportService } from './estimate-overview-report/estimate-overview-report.service';
import { SolGraphicsReportService } from './sol-graphics-report/sol-graphics-report.service';
import { LaborByLevelService } from './labor-by-level/labor-by-level.service';
import { CostByLevelService } from './cost-by-level/cost-by-level.service';
import { ReportDispatcherService } from './report-dispatcher/report-dispatcher.service';

export const REPORT_PROVIDERS: Provider[] = [
  ReportDispatcherService,
  SolLaborReportsService,
  SolCostReportService,
  SolSubContractorMiscellaneousService,
  SolSystemsReportService,
  SolMaterialService,
  SolChecklistBaseService,
  FireEstimatingService,
  TaskBasedLaborService,
  ElectricalReportService,
  SolMaterialRelatedReportsService,
  SolMaterialByAreaService,
  SolMaterialByCountryService,
  WiringTypesService,
  SpecialPricingReportService,
  EstimateOverviewReportService,
  SolGraphicsReportService,
  LaborByLevelService,
  CostByLevelService
];
